export const RECOMMENDED_DAILY_INVITE = 25;
